import script from "./insureCount.vue?vue&type=script&setup=true&lang=js"
export * from "./insureCount.vue?vue&type=script&setup=true&lang=js"

import "./insureCount.vue?vue&type=style&index=0&id=2578d746&lang=scss"

const __exports__ = script;

export default __exports__